"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var field_descriptor_1 = require("./field-descriptor");
var protobuf_field_1 = require("./protobuf-field");
var wire_type_1 = require("./wire-type");
function base64ToBin(dataBase64) {
    return Buffer.from(dataBase64, 'base64');
}
function protobufUnframe(data) {
    var is_compressed = data[0];
    if (is_compressed) {
        throw new Error("Compressed protobuf frames are not supported");
    }
    var size = data.readUInt32BE(1);
    var unframedData = data.slice(5);
    if (size !== unframedData.length) {
        unframedData.slice(0, size);
        throw new Error("More than one message in protobuf payload is not supported, taking first");
    }
    return unframedData;
}
var ProtobufDecoder = /** @class */ (function () {
    function ProtobufDecoder(dataBase64, isFramed) {
        var data = base64ToBin(dataBase64);
        if (isFramed) {
            data = protobufUnframe(data);
        }
        this.data = data;
        this.offset = 0;
        this.strings = [];
    }
    ProtobufDecoder.prototype.decode = function () {
        return this.parseMessage(0, this.data.length);
    };
    ProtobufDecoder.prototype.parseMessage = function (offset, end) {
        var fields = [];
        while (offset < end) {
            var _a = this.parseFieldTag(offset, end), newOffset = _a[0], wireType = _a[1], fieldNumber = _a[2];
            offset = newOffset;
            if (wireType == wire_type_1.default.TYPE_VARINT) {
                var _b = this.parseVarint(offset, end), num = _b[0], newOffset_1 = _b[1];
                offset = newOffset_1;
                var field = new protobuf_field_1.default(fieldNumber, field_descriptor_1.default.TYPE_INT32, [num]);
                fields.push(field);
            }
            else if (wireType === wire_type_1.default.TYPE_FIXED32) {
                var _c = this.parseFixed(offset, end, 4), newOffset_2 = _c[0], val = _c[1], isFloat = _c[2];
                offset = newOffset_2;
                var ftype = isFloat ? field_descriptor_1.default.TYPE_FLOAT : field_descriptor_1.default.TYPE_FIXED32;
                var field = new protobuf_field_1.default(fieldNumber, ftype, [val]);
                fields.push(field);
            }
            else if (wireType === wire_type_1.default.TYPE_FIXED64) {
                var _d = this.parseFixed(offset, end, 8), newOffset_3 = _d[0], val = _d[1], isFloat = _d[2];
                offset = newOffset_3;
                var ftype = isFloat ? field_descriptor_1.default.TYPE_DOUBLE : field_descriptor_1.default.TYPE_FIXED64;
                var field = new protobuf_field_1.default(fieldNumber, ftype, [val]);
                fields.push(field);
            }
            else if (wireType === wire_type_1.default.TYPE_LENGTH_DELIMITED) {
                var _e = this.parseVarint(offset, end), fieldLen = _e[0], newOffset_4 = _e[1];
                offset = newOffset_4;
                try {
                    var buf = this.data.slice(offset, offset + fieldLen);
                    if ((fieldLen > 2) && (this.data[offset] < 32 || this.data[offset + 1] < 32)) {
                        throw new Error("Likely not a string: " + buf.toString('hex'));
                    }
                    var val = buf.toString('utf8');
                    // eslint-disable-next-line no-control-regex
                    if (val.search(/[\u0000-\u0019]/) !== -1) {
                        throw new Error("Likely not a string: " + buf.toString('hex'));
                    }
                    var field = new protobuf_field_1.default(fieldNumber, field_descriptor_1.default.TYPE_STRING, [val]);
                    fields.push(field);
                }
                catch (error) { // TODO: Use specific error class
                    var submsg = this.parseMessage(offset, offset + fieldLen);
                    var field = new protobuf_field_1.default(fieldNumber, field_descriptor_1.default.TYPE_MESSAGE, submsg.values);
                    fields.push(field);
                }
                offset = offset + fieldLen;
            }
            else {
                throw new Error("Unsupported wire type: " + wireType);
            }
        }
        if (offset !== end) {
            throw new Error('Decoding process quick before completion');
        }
        return new protobuf_field_1.default(0, field_descriptor_1.default.TYPE_MESSAGE, fields);
    };
    ProtobufDecoder.prototype.parseFieldTag = function (start, end) {
        var wireType = this.data.readUInt8(start) & 0x7;
        var _a = this.parseVarint(start, end), varint = _a[0], offset = _a[1];
        var fieldNumber = varint >> 3;
        return [offset, wireType, fieldNumber];
    };
    ProtobufDecoder.prototype.parseVarint = function (start, end) {
        var bytesArr = [];
        var pos = 0;
        var isDone = false;
        while (start + pos < end) {
            var oneByte = this.data.readUInt8(start + pos);
            bytesArr.push(oneByte & 0x7F);
            pos++;
            if ((oneByte & 0x80) === 0x00) {
                isDone = true;
                break;
            }
        }
        if (!isDone) {
            throw new Error("Failed to parse protobuf tag");
        }
        var index = bytesArr.length - 1;
        var val = 0;
        while (index >= 0) {
            val = (val << 7) + bytesArr[index];
            index--;
        }
        return [val, start + pos];
    };
    ProtobufDecoder.prototype.parseFixed = function (offset, end, size) {
        // TODO: detect signed types
        var num;
        var isFloat = true;
        if (size == 4) {
            try {
                num = this.data.readFloatBE(offset);
            }
            catch (error) {
                num = this.data.readUInt32BE(offset);
                isFloat = true;
            }
        }
        else if (size == 8) {
            try {
                num = this.data.readDoubleBE(offset);
            }
            catch (error) {
                num = this.data.readBigUInt64BE(offset);
                isFloat = true;
            }
        }
        offset += size;
        return [offset, num, isFloat];
    };
    return ProtobufDecoder;
}());
exports.default = ProtobufDecoder;
